import React, { useState } from 'react';

const RoomCreationForm = ({ onCreate, onCancel }) => {
  const [name, setName] = useState('');
  const [language, setLanguage] = useState('');
  const [nativeLanguage, setNativeLanguage] = useState('');
  const [level, setLevel] = useState('');
  const [description, setDescription] = useState('');
  const [bannerFile, setBannerFile] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);

  const handleBannerChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('Only JPG, PNG, GIF, and WEBP images are allowed.');
      return;
    }
    setBannerFile(file);
    setBannerPreview(URL.createObjectURL(file));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !language || !level || !description) return;
    onCreate({
      name,
      language,
      native_language: nativeLanguage || null,
      level,
      description,
      bannerFile,
    });
  };

  return (
    <form className="create-room-form" onSubmit={handleSubmit}>
      <h2>Create a New Room</h2>

      <input
        type="text"
        placeholder="Room Name"
        value={name}
        onChange={e => setName(e.target.value)}
        required
      />

      <select
        value={language}
        onChange={e => setLanguage(e.target.value)}
        required
      >
        <option value="">Select Target Language</option>
        <option value="English">English</option>
        <option value="Spanish">Spanish</option>
        <option value="French">French</option>
        <option value="German">German</option>
        <option value="Italian">Italian</option>
        <option value="Portuguese">Portuguese</option>
        <option value="Russian">Russian</option>
        <option value="Chinese">Chinese</option>
        <option value="Japanese">Japanese</option>
        <option value="Korean">Korean</option>
        <option value="Arabic">Arabic</option>
        <option value="Other">Other</option>
      </select>

      <select
        value={nativeLanguage}
        onChange={e => setNativeLanguage(e.target.value)}
      >
        <option value="">Native Language (optional)</option>
        <option value="English">English</option>
        <option value="Spanish">Spanish</option>
        <option value="French">French</option>
        <option value="German">German</option>
        <option value="Italian">Italian</option>
        <option value="Portuguese">Portuguese</option>
        <option value="Russian">Russian</option>
        <option value="Chinese">Chinese</option>
        <option value="Japanese">Japanese</option>
        <option value="Korean">Korean</option>
        <option value="Arabic">Arabic</option>
        <option value="Other">Other</option>
      </select>

      <select
        value={level}
        onChange={e => setLevel(e.target.value)}
        required
      >
        <option value="">Select Level (CEFR)</option>
        <option value="A1">A1 (Beginner)</option>
        <option value="A2">A2 (Elementary)</option>
        <option value="B1">B1 (Intermediate)</option>
        <option value="B2">B2 (Upper Intermediate)</option>
        <option value="C1">C1 (Advanced)</option>
        <option value="C2">C2 (Proficient)</option>
      </select>

      <textarea
        placeholder="Describe the room focus, topics, or expectations"
        value={description}
        onChange={e => setDescription(e.target.value)}
        rows={4}
        required
      />

      <div className="banner-upload-field">
        <label htmlFor="room-banner-input" className="banner-label">
          Room Banner (optional)
        </label>
        <input
          id="room-banner-input"
          type="file"
          accept="image/*"
          onChange={handleBannerChange}
        />
        <div className="banner-helper">Square-ish images look best.</div>
        {bannerFile && (
          <div className="banner-file-name">{bannerFile.name}</div>
        )}
        {bannerPreview && (
          <div className="banner-preview">
            <img src={bannerPreview} alt="Room banner preview" />
          </div>
        )}
      </div>

      <div className="create-room-actions">
        <button type="submit">Create Room</button>
        <button type="button" className="ghost" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
};

export default RoomCreationForm;